<div class="page-container gap-24">
  <div class="page-title justify-space-between">
    <span class="font-bold-display-medium"> Rechnungen </span>
    <div class="flex-r gap-16 align-center">
      <div style="min-width: 150px">
        <p-select
          [(ngModel)]="selectedYear"
          [options]="yearOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Jahr auswählen..."
          class="align-self-stretch" />
      </div>
      <button
        class="inwi-text-button-medium-primary"
        (click)="exportInvoicesZip()"
        pTooltip="Alle Rechnungen als ZIP exportieren (Jahrespaket)"
        tooltipPosition="left">
        <div class="button-content">
          <i class="fa-regular fa-file-archive button-icon"></i>
          <div class="button-text">Als ZIP exportieren</div>
        </div>
      </button>
    </div>
  </div>

  <app-custom-table
    class="padding-bottom-24"
    [pageSize]="50"
    [pageSizeOptions]="[5, 10, 25, 50, 100]"
    titleMultipleResults="Rechnungen"
    titleSingleResult="Rechnung"
    [dataSource$]="dataSource$"
    [columns]="columns"
    [isLoading]="isLoading"
    [filters]="filters"
    noDataIcon="fa-receipt"
    noDataMessage="Es gibt derzeit keine Rechnungen."
    noSearchResultsIcon="fa-receipt"
    noSearchResultsMessage="Es gibt keine Rechnungen, die mit deinen Suchkriterien übereinstimmen." />
</div>
